import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedDirectivesModule } from '../directives/shared-directives.module';

import { ImageViewerSdmComponent } from './image-viewer-sdm/image-viewer-sdm.component';
import { EditDateComponent } from './edits/edit-date/edit-date.component';


@NgModule({
  declarations: [
    ImageViewerSdmComponent,
    EditDateComponent
  ],
  exports: [
    ImageViewerSdmComponent,
    EditDateComponent
  ],
  imports: [
    CommonModule,
    SharedDirectivesModule
  ]
})
export class SharedComponentsModule { }
